"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.meUserFragment = void 0;
const client_1 = require("@apollo/client");
exports.meUserFragment = client_1.gql `
  fragment meUser on User {
    __typename
    id
    email
    firstName
    lastName
    numRecipes
    createdAt
    paddleCancelUrl
    paddleUpdateUrl
    role {
      type
      endDate
      recipeLimit
    }
  }
`;
//# sourceMappingURL=meUser.js.map